import * as React from "react";

export const ModalWarning = ({ children }: React.PropsWithChildren<{}>) => {
    return (
        <>
            <p style={{ fontSize: 100 + 'px' }} className="text-center text-warning">
                <i id="FailureStatus" className="fa fa-exclamation-circle" aria-hidden="true"></i>
            </p>
            <p className="text-center">
                {children}
            </p>
        </>
    );
}
